import type { Module } from "@webmotors/ioc";
import { LocalStorageModule } from "@packages/common";
import { CookieConsentsService } from "./cookie-consents.service";

export const CookieConsentsModule: Module = {
  name: "CookieConsentsModule",
  modules: [LocalStorageModule],
  providers: [CookieConsentsService],
};
